var render = function render(_c,_vm){return _c('div',{staticStyle:{"align-content":"center"}},[(
      _vm.props.row.approval_range_details &&
      _vm.props.row.approval_range_details.length
    )?_c('div',_vm._l((_vm.props.row.approval_range_details),function(detail,index){return _c('div',{key:index},[_c('strong',[_c('translate-text',{attrs:{"keyTranslate":"shopping.range"}}),_vm._v(" "+_vm._s(index + 1)+":\n      ")],1),(detail.deleted_at)?_c('div',[_c('translate-text',{attrs:{"keyTranslate":"common_words.disable"}})],1):_c('div',[_c('translate-text',{attrs:{"keyTranslate":"common_words.enable"}})],1)])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }